import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Deliberately render() rather than hydrateRoot(), even though
// scripts/prerender.js puts real markup in #root. Do not "optimise" this back.
//
// The prerendered HTML is a serialised live DOM, not renderToString output, and
// the two are not interchangeable. Serialising merges adjacent text nodes,
// which real SSR prevents with `<!-- -->` separators; it also loses the
// bookkeeping React's hydration matcher depends on. Tried it: every route threw
// React #418 and then #423 — "the entire root will switch to client rendering".
// So hydration bought nothing and cost thirteen console errors and four points
// of Lighthouse Best Practices.
//
// Measured both ways, render() wins: same CLS (0), same performance score, zero
// console errors. The prerendered HTML still does its real job — crawlers get
// full content, and visitors get a styled first paint rather than a blank page,
// because the prerenderer inlines the Emotion CSS alongside the markup.
ReactDOM.createRoot(container).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
